import {
    NAME_OVERVIEW,
    NAME_PRODUCTS,
    NAME_TASKS,
    NAME_BRAND_ASSETS,
    NAME_CONTENT_AGREEMENT,
    NAME_COMPENSATION,
    NAME_PERSONAL_INFO,
} from '../../../../constants/activation-brief-steps';

const moduleExpands = {
    [NAME_OVERVIEW]: [
        'brand',
        'files',
        'content_rights',
        'tasks',
        'product_configs.items.category',
        'product_configs.items.items',
        'product_configs.items.items.category',
        'custom_fields',
        'payment_configs',
        'tracking_tags',
        'conversion_configs',
    ],
    [NAME_TASKS]: [
        'brand',
        'tasks',
        'tracking_tags',
    ],
    [NAME_PRODUCTS]: [
        'brand',
        'product_configs.items.category',
        'product_configs.items.items',
        'product_configs.items.items.category',
    ],
    [NAME_COMPENSATION]: [
        'brand',
        'payment_configs',
        'conversion_configs',
    ],
    [NAME_BRAND_ASSETS]: [
        'brand',
        'files',
    ],
    [NAME_CONTENT_AGREEMENT]: [
        'content_rights',
        'files',
    ],
    [NAME_PERSONAL_INFO]: [],
};

export default {
    methods: {
        fetchActivation(activationId, moduleName) {
            const expands = moduleExpands[moduleName].map(resource => 'expand[]=' + resource).join('&');
            const url = `/api/v1/activations/${activationId}${expands ? `?${expands}`: ''}`;

            return this.$http.get(url);
        },
        fetchActivationFields(activationId) {
            const url = `/api/v1/activations/${activationId}/fields`;
            return this.$http.get(url);
        },
    },
};
